function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import CloseIcon from '@mui/icons-material/Close';
import { IconButton as MuiIconButton, styled } from '@mui/material';
var CloseIconButton = styled(MuiIconButton, {})(function(param) {
    var theme = param.theme;
    return {
        position: 'absolute',
        right: 8,
        top: 8,
        color: theme.palette.action.active
    };
});
export var ModalCloseButton = function(param) {
    var handleClose = param.handleClose, sx = param.sx, iconSx = param.iconSx, id = param.id;
    var t = useTranslation('main').t;
    return /*#__PURE__*/ _jsx(CloseIconButton, {
        "aria-label": t('common.aria.close'),
        onClick: handleClose,
        sx: _object_spread({}, sx),
        id: id,
        children: /*#__PURE__*/ _jsx(CloseIcon, {
            sx: _object_spread({
                fontSize: 24
            }, iconSx)
        })
    });
};
